'use server';

import { internalApi } from '../api-client/internal-api-client';
import {
  ActionResult,
  getRequiredSessionToken,
  requireWriteActionCsrf,
  toActionError,
} from './action-utils';

export async function listNotificationsAction(): Promise<ActionResult<any[]>> {
  try {
    const token = await getRequiredSessionToken();
    const res = await internalApi.get('/notifications', { sessionToken: token });
    return { data: (res.data ?? []) as any[] };
  } catch (error) {
    return toActionError(error, 'Benachrichtigungen konnten nicht geladen werden.');
  }
}

export async function getNotificationPreferencesAction(): Promise<ActionResult<any[]>> {
  try {
    const token = await getRequiredSessionToken();
    const res = await internalApi.get('/notifications/preferences', { sessionToken: token });
    return { data: (res.data ?? []) as any[] };
  } catch (error) {
    return toActionError(error, 'Benachrichtigungseinstellungen konnten nicht geladen werden.');
  }
}

export async function unreadNotificationCountAction(): Promise<ActionResult<{ count: number }>> {
  try {
    const token = await getRequiredSessionToken();
    const res = await internalApi.get('/notifications/unread-count', { sessionToken: token });
    return { data: (res.data ?? { count: 0 }) as { count: number } };
  } catch (error) {
    return toActionError(error, 'Ungelesene Benachrichtigungen konnten nicht geladen werden.');
  }
}

export async function markNotificationReadAction(input: {
  csrfToken?: string;
  publicId: string;
}): Promise<ActionResult<any>> {
  try {
    const token = await requireWriteActionCsrf(input.csrfToken);
    const res = await internalApi.post(
      `/notifications/${input.publicId}/mark-read`,
      {},
      { sessionToken: token },
    );
    return { data: res.data };
  } catch (error) {
    return toActionError(error, 'Benachrichtigung konnte nicht als gelesen markiert werden.');
  }
}

export async function dismissNotificationAction(input: {
  csrfToken?: string;
  publicId: string;
}): Promise<ActionResult<any>> {
  try {
    const token = await requireWriteActionCsrf(input.csrfToken);
    const res = await internalApi.post(
      `/notifications/${input.publicId}/dismiss`,
      {},
      { sessionToken: token },
    );
    return { data: res.data };
  } catch (error) {
    return toActionError(error, 'Benachrichtigung konnte nicht ausgeblendet werden.');
  }
}

export async function updateNotificationPreferencesAction(input: {
  csrfToken?: string;
  entries: any[];
}): Promise<ActionResult<any[]>> {
  try {
    const token = await requireWriteActionCsrf(input.csrfToken);
    const res = await internalApi.patch(
      '/notifications/preferences',
      { entries: input.entries },
      { sessionToken: token },
    );
    return { data: (res.data ?? []) as any[] };
  } catch (error) {
    return toActionError(
      error,
      'Benachrichtigungseinstellungen konnten nicht aktualisiert werden.',
    );
  }
}
